<template>

  <v-text-field @input="onInput" :type="type"
    :error-messages="errorMessages"
    :label="label" v-model="formatedValue"
    :counter="counter">
  </v-text-field>

</template>

<script type="text/javascript">
  import Cleave from 'cleave.js';

  export default {
    props: {
      value: {
        default: null,
        required: true,
        validator(value) {
          return value === null || typeof value === 'string' ||
            value instanceof String || typeof value === 'number';
        },
      },
      // https://github.com/nosir/cleave.js/blob/master/doc/options.md
      options: {
        type: Object,
        default: () => ({}),
      },
      // Set this prop to false to emit masked value
      raw: {
        type: Boolean,
        default: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'text',
      },
      label: {
        type: String,
        default: 'Data',
      },
      counter: {
        type: Number,
        default: null,
      },
      errorMessages: {
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        // cleave.js instance
        cleave: null,
        formatedValue: null,
      };
    },
    mounted() {
      /* istanbul ignore if */
      if (this.cleave) return;
      const input = this.$el.querySelector('input');
      this.cleave = new Cleave(input, this.options);
      this.cleave.setRawValue(this.value);
    },
    methods: {
      /**
       * Watch for value changed by cleave and notify parent component
       * Note: we have to wait for DOM to get updated by cleave.js in order to get final value
       *
       * @param event
       */
      onInput(event) {
        this.$nextTick(() => {
          const value = this.raw ? this.cleave.getRawValue() : event.target.value;
          this.$emit('input', value);
        });
      },
    },
    watch: {
      /**
       * Watch for any changes in options and redraw
       *
       * @param newOptions Object
       */
      options: {
        deep: true,
        handler(newOptions) {
          this.cleave.destroy();
          const input = this.$el.querySelector('input');
          this.cleave = new Cleave(input, newOptions);
          this.cleave.setRawValue(this.value);
        },
      },
      /**
       * Watch for changes from parent component and notify cleave instance
       *
       * @param newValue
       */
      value(newValue) {
        if (this.cleave) {
          this.cleave.setRawValue(newValue);
          this.formatedValue = this.cleave.getFormattedValue();
        }
      },
    },
    beforeDestroy() {
      // Free up memory
      /* istanbul ignore else */
      if (this.cleave) {
        this.cleave.destroy();
        this.cleave = null;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/widgets/PrInputMask.vue